const API_BASE: string = (process.env.REACT_APP_API_BASE || 'http://localhost:5000').replace(/\/$/, '');

function authHeaders(): Record<string, string> {
    const token = localStorage.getItem('token');
    return {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
    };
}

export type ArchiveTimelineItem = {
    year: string;
    text: string;
};

export type ArchiveProfile = {
    _id: string;
    slug: string;
    name: string;
    title: string;
    era: string;
    discipline: string;
    summary: string;
    portraitTone: string;
    initials: string;
    themes: string[];
    timeline: ArchiveTimelineItem[];
    works: string[];
    quote: string;
    quoteContext: string;
    followerCount: number;
    isFollowing: boolean;
};

async function parseJson<T>(res: Response): Promise<T> {
    const data = await res.json().catch(() => ({}));
    if (!res.ok) {
        throw new Error(data?.message || `Request failed: ${res.status}`);
    }
    return data;
}

export async function fetchArchiveProfiles(): Promise<ArchiveProfile[]> {
    const res = await fetch(`${API_BASE}/api/archive-profiles`, {
        headers: authHeaders(),
    });
    const data = await parseJson<{ success: boolean; profiles: ArchiveProfile[] }>(res);
    return data.profiles || [];
}

export async function fetchArchiveProfile(slug: string): Promise<ArchiveProfile> {
    const res = await fetch(`${API_BASE}/api/archive-profiles/${encodeURIComponent(slug)}`, {
        headers: authHeaders(),
    });
    const data = await parseJson<{ success: boolean; profile: ArchiveProfile }>(res);
    return data.profile;
}

export async function toggleArchiveFollow(slug: string): Promise<{ isFollowing: boolean; followerCount: number }> {
    const res = await fetch(`${API_BASE}/api/archive-profiles/${encodeURIComponent(slug)}/follow`, {
        method: 'POST',
        headers: authHeaders(),
    });
    return parseJson<{ success: boolean; isFollowing: boolean; followerCount: number }>(res);
}
